import { Modal } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";
import { getQuestionLimit } from '../../utils/QuestionLimit.js';
import { calculateApiCalls } from '../../utils/QuestionLimit.js';

const ContentInfoModal = ({
    open,
    onClose,
    handleContentInfoModalOk,
    wordCount
}) =>{

     const TIERTYPE = localStorage.getItem("TIERTYPE");
     const user_tier = TIERTYPE === 'tier2_monthly' || TIERTYPE === "tier2_annually"? 2 : 1; 
     const QuestionLimitNo = localStorage.getItem("QuestionLimitNo");
     const version = localStorage.getItem('Version');

const questionLimit = getQuestionLimit(wordCount);
const apicalls = calculateApiCalls(wordCount);
  
const isSampleButtonClicked = localStorage.getItem('isSampleButtonClicked');
return(
    <Modal
  open={open}
  onClose={onClose}
  aria-labelledby="content-info-modal-title"
  className="flex place-content-center items-center fixed animate-fade-slide-down outline-none"
  BackdropProps={{
    style: { pointerEvents: "auto" },
  }}
>
  <div className="bg-white shadow-lg text-[#212529] p-6 rounded-lg animate-fade-slide-down w-max">
    <div className="flex place-content-between border-b pb-5">
      <h2 className="text-xl font-semibold">
        Content Information
      </h2>
      <Tooltip
        title="Close"
        arrow
        placement="top"
        TransitionComponent={Zoom}
        TransitionProps={{ timeout: 300 }}
      >
        <button
          className="text-[#6c757d] text-lg hover:bg-[#edeeef] px-2 rounded-full transition-all ease-in-out duration-500"
          onClick={onClose}
        >
          <i className="fa-solid fa-xmark"></i>
        </button>
      </Tooltip>
    </div>
    <div className="py-6 border-b">
      <p>
        <span>
          <i className="fa-solid fa-circle-info text-blue-400 pe-2"></i>
        </span>
        Total source content considered is: <span className="font-semibold">{wordCount}</span> words.
      </p>
      {
        isSampleButtonClicked ? 
      (
          <p className="mt-3">
        <span>
          <i className="fa-solid fa-circle-info text-blue-400 pe-2"></i>
        </span>
        Total questions generated as per source content word count is: <span className="font-semibold">{7}</span>.
      </p>
       ) :(
          <p className="mt-3">
        <span>
          <i className="fa-solid fa-circle-info text-blue-400 pe-2"></i>
        </span>
        Total questions generated as per source content word count is: <span className="font-semibold">{questionLimit}</span>.
      </p>
       )
      }
     {
      isSampleButtonClicked ? 
      " " :
       <p className="mt-3">
        <span>
          <i className="fa-solid fa-circle-info text-blue-400 pe-2"></i>
        </span>
        Total number of Quiz consumed is: <span className="font-semibold">{apicalls}</span>.
      </p>
     }
    </div>
    <div className="flex place-content-center gap-72 mt-4">
      <Tooltip
        title="Cancel"
        arrow
        placement="top"
        TransitionComponent={Zoom}
        TransitionProps={{ timeout: 300 }}
      >
        <button
          className="rounded mt-4 px-6 py-2 hover:opacity-90 text-[#6c757d] hover:bg-[#6c757d] hover:border-[#6c757d] hover:text-white border border-[#6c757d] transition-all ease-in-out duration-500"
          onClick={onClose}
        >
          Cancel
        </button>
      </Tooltip>
      <Tooltip
        title="Ok"
        arrow
        placement="top"
        TransitionComponent={Zoom}
        TransitionProps={{ timeout: 300 }}
      >
        <button
          className="mt-4 px-6 py-2 bg-[#c2fbd7] text-[#1a582a] font-semibold rounded hover:bg-[#b0fccd] transition-all ease-in-out duration-500"
          onClick={handleContentInfoModalOk}
        >
          Ok
        </button>
      </Tooltip>
    </div>
  </div>
</Modal>
)
}

export default ContentInfoModal;